import { data } from '../../svg/Description/data';
import { makeIcon } from '../makeIcon';

export const Description = makeIcon(data, 'description', 'Description');

export default Description;
